import { Cart } from '@bao/cart'
import { BAOCustomElement } from '@bao/custom-element'

export class ProductForm extends BAOCustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
